import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Console from "./pages/Console";
import Team from "./pages/Team";
import Player from "./pages/Player";
import Guide from "./pages/Guide";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/console" element={<Console />} />
          <Route path="/team" element={<Team />} />
          <Route path="/play" element={<Player />} />
          <Route path="/guide" element={<Guide />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
